import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonFunctions } from './common-functions';
import { BranchServiceProxy } from './services/branch.service';
import { CompanyServiceProxy } from './services/company.service';
import { DepartmentServiceProxy } from './services/department.service';
import { RoleServiceProxy } from './services/role.service';
import { UserServiceProxy } from './services/user.service';
import { NotifiationServiceProxy } from './services/notifiation.service';
import { BankServiceProxy } from './services/bank.service';
import { DesignationServiceProxy } from './services/designation.service';
import { DocumentTypesServiceProxy } from './services/document-types.service';
import { ProfessionalTaxServiceProxy } from './services/professional-tax.service';
import { ShiftServiceProxy } from './services/shift.service';
import { HRMSInterceptor } from 'app/shared/interceptor/app-interceptor'
import { HolidayNameServiceProxy } from './services/holiday-name.service';
import { LeaveApplicationServiceProxy } from './services/leave-application.service'
import { LeaveTypeServiceProxy } from './services/leave-type.service';
import { PaymentTypeServiceProxy } from './services/payment-type.service';
import { EmployeeServiceProxy } from './services/employee.service';
import { PayrollServiceProxy } from './services/payroll.service';
import { ThumbApplicationServiceProxy } from './services/thumb-application.service';
import { CommonEnumValuesServiceProxy } from './services/common-enum-values.service';
import { MenuAccessServiceProxy } from './services/menu-access.service';
import { HolidayApplicationServiceProxy } from './services/holiday-application.service';
import { OverTimeApplicationServiceProxy } from './services/over-time-application.service';
import { ResignApplicationServiceProxy } from './services/resign-application.service';
import { ExtraPayApplicationServiceProxy } from './services/extra-pay-application.service';
import { ReportServiceProxy } from './services/report.service';
import { InstructionServiceProxy } from './services/instruction.service';
import { EmployeeDayFlagAdjustServiceProxy } from './services/employee-day-flag-adjust.service';
import { LocationServiceProxy } from './services/location.service';
import { RequestServiceProxy } from './services/request.service';
import { GetAllNotificationByUserIdServiceProxy } from './services/get-all-notification-by-user-id.service';
import { NotificationServiceProxy } from './services/notification.service';
import { EmployeeDashboardServiceProxy } from './services/employee-dashboard.service';
import { AdminDashboardServiceProxy } from './services/admin-dashboard.service';
import { DeviceSettingServiceProxy } from './services/device-setting.service';
import { PermanentEmployeeServiceProxy } from './services/permanent-employee.service';
import { WorkFromHomeServiceProxy } from './services/work-from-home.service';
import { EmailSettingServiceProxy } from './services/email-setting.service';
import { EmailTemaplateServiceProxy } from './services/email-temaplate.service';
import { ClarificationServiceProxy } from './services/clarification.service';
import { InvestmentDetailServiceProxy } from './services/investment-detail.service';
import { InvestmentSchemaServiceProxy } from './services/investment-schema.service';
import { ITSlabServiceProxy } from './services/it-slab.service';
import { FinancialYearServiceProxy } from './services/financial-year.service';
import { FormDetailServiceProxy } from './services/form-detail.service';
import { EmployeeAdditionalSalaryServiceProxy } from './services/employee-additional-salary.service';
import { EmployeeITMethodServiceProxy } from './services/employee-it-method.service';
import { RuleServiceProxy } from "./services/rule.service";
import { ShiftGroupServiceProxy } from "./services/shift-group.service";
import { EmployeeShiftServiceProxy } from './services/employee-shift.service';
import { SettingServiceProxy } from './services/setting.service';
import { WeeklySettingServiceProxy } from './services/weekly-setting.service';
import { FuelAllowanceApplicationServiceProxy } from './services/fuel-allowance-application.service';
import { FuelAllowanceServiceProxy } from './services/fuel-allowance.service';
import { ProjectServiceProxy } from './services/project.service';
import { PFServiceProxy } from './services/pf.service';
import { LWFServiceProxy } from './services/lwf.service';
import { ESICServiceProxy } from './services/esic.service';
import { AllowanceServiceProxy } from './services/allowance.service';
import { SalaryStructureServiceProxy } from './services/salary-structure.service';
import { SalaryStructureDetailServiceProxy } from './services/salary-structure-detail.service';
import { EmployeeRelationServiceProxy } from './services/employee-relation.service';
import { DailyTravellingAllowanceServiceProxy } from './services/daily-travelling-allowance.service';
import { CompensationServiceProxy } from './services/Compensation.service';
import { CompensationApplicationServiceProxy } from './services/compensation-application.service';
import { BonusServiceProxy } from './services/bonus.service';
import { LeaveEncashmentServiceProxy } from './services/leave-encashment.service';
import { AdvancePaidServiceProxy } from './services/advance-paid.service';
import { CheckListServiceProxy } from './services/check-list.service';
import { EmployeeCheckListServiceProxy } from './services/employee-check-list.service';
import { CustomEmailServiceProxy } from './services/custom-email.service';
import { EducationServiceProxy } from './services/education.service';
import { DocumentVaultServiceProxy } from './services/document-vault.service';
import { EmployeeTrainingServiceProxy } from './services/employee-training.service';
import { AssetMasterServiceProxy } from './services/asset-master.service';
import { AssetManagementServiceProxy } from './services/asset-management.service';
import { AccountServiceProxy } from './services/account.service';
import { ExpenseCategoryServiceProxy } from './services/expense-category.service';
import { ProjectIncomeServiceProxy } from './services/project-income.service';
import { ExpenseServiceProxy } from './services/expense.service';
import { ExpenseDashboardServiceProxy } from './services/expense-dashboard.service';
import { InternServiceProxy } from './services/intern.service';
import { InternFeeServiceProxy } from './services/intern-fee.service';


@NgModule({
    providers: [
        CommonFunctions,
        UserServiceProxy,
        RoleServiceProxy,
        CompanyServiceProxy,
        DepartmentServiceProxy,
        BranchServiceProxy,
        HolidayNameServiceProxy,
        BankServiceProxy,
        CompanyServiceProxy,
        DesignationServiceProxy,
        DocumentTypesServiceProxy,
        ProfessionalTaxServiceProxy,
        ShiftServiceProxy,
        LeaveTypeServiceProxy,
        PaymentTypeServiceProxy,
        EmployeeServiceProxy,
        HolidayApplicationServiceProxy,
        ThumbApplicationServiceProxy,
        CommonEnumValuesServiceProxy,
        OverTimeApplicationServiceProxy,
        LeaveApplicationServiceProxy,
        CommonEnumValuesServiceProxy,
        HolidayApplicationServiceProxy,
        ResignApplicationServiceProxy,
        MenuAccessServiceProxy,
        CommonEnumValuesServiceProxy,
        ExtraPayApplicationServiceProxy,
        ReportServiceProxy,
        PayrollServiceProxy,
        InstructionServiceProxy,
        NotifiationServiceProxy,
        EmployeeDayFlagAdjustServiceProxy,
        LocationServiceProxy,
        RequestServiceProxy,
        NotifiationServiceProxy,
        GetAllNotificationByUserIdServiceProxy,
        NotificationServiceProxy,
        EmployeeDashboardServiceProxy,
        AdminDashboardServiceProxy,
        DeviceSettingServiceProxy,
        PermanentEmployeeServiceProxy,
        WorkFromHomeServiceProxy,
        EmailSettingServiceProxy,
        EmailTemaplateServiceProxy,
        ClarificationServiceProxy,
        InvestmentDetailServiceProxy,
        InvestmentSchemaServiceProxy,
        ITSlabServiceProxy,
        FinancialYearServiceProxy,
        FormDetailServiceProxy,
        EmployeeAdditionalSalaryServiceProxy,
        EmployeeITMethodServiceProxy,
        RuleServiceProxy,
        ShiftGroupServiceProxy,
        EmployeeShiftServiceProxy,
        SettingServiceProxy,
        WeeklySettingServiceProxy,
        FuelAllowanceApplicationServiceProxy,
        FuelAllowanceServiceProxy,
        ProjectServiceProxy,
        PFServiceProxy,
        LWFServiceProxy,
        ESICServiceProxy,
        AllowanceServiceProxy,
        SalaryStructureServiceProxy,
        SalaryStructureDetailServiceProxy,
        EmployeeRelationServiceProxy,
        DailyTravellingAllowanceServiceProxy,
        CompensationServiceProxy,
        CompensationApplicationServiceProxy,
        BonusServiceProxy,
        LeaveEncashmentServiceProxy,
        AdvancePaidServiceProxy,
        CheckListServiceProxy,
        EmployeeCheckListServiceProxy,
        CustomEmailServiceProxy,
        EducationServiceProxy,
        DocumentVaultServiceProxy,
        EmployeeTrainingServiceProxy,
        AssetMasterServiceProxy,
        AssetManagementServiceProxy,
        AccountServiceProxy,
        ExpenseCategoryServiceProxy,
        ProjectIncomeServiceProxy,
        ExpenseServiceProxy,
        ExpenseDashboardServiceProxy,
        InternServiceProxy,
        InternFeeServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: HRMSInterceptor, multi: true },
    ],
})
export class ServiceProxyModule { }
